import React from "react";
import "./ViewPhotoSamplePopup.scss";
import correctPhoto from "../../../assets/PhotographSample/correctPhoto.jpg";
import hatCovered from "../../../assets/PhotographSample/hat-covered.svg";
import sunGlass from "../../../assets/PhotographSample/sunglass-covered.svg";
import shadow from "../../../assets/PhotographSample/shadow-covered.svg";
import BottomPanel from "../../BottomPanel/BottomPanel";
export interface IViewPhotoSampleMobileViewProps {
  setShowPopup: Function;
  showPopup: boolean;
  text?: any;
  children?: any;
}
const ViewPhotoSampleMobileViewProps = (props: IViewPhotoSampleMobileViewProps) => {
  const getMobileUIPopup = () => {
    return (
      <div className="mobile-view" role="dialog" aria-modal="true" aria-labelledby="photo-sample-mobile-title">
        <h2 className="mobile-view-text" id="photo-sample-mobile-title">Guide for Photo Upload</h2>
        <div className="grid">
          <div className="box-1">
            <div className="profile-container">
              <img
                src={correctPhoto}
                alt="Example of a valid clear selfie photo"
                className="profile-image"
              />
              <div className="checkmark" aria-hidden="true">✔</div>
            </div>
            <p className="success">
              Take a selfie facing the camera with a clear background.
            </p>
          </div>

          <div className="box-1">
            <img src={hatCovered} alt="Invalid photo with hat covering face" height={80} width={120} />
            <p className="error"> Don’t wear a hat.</p>
          </div>

          <div className="box-1">
            <img src={sunGlass} alt="Invalid photo with sunglasses" height={80} width={120} />
            <p className="error"> Don’t wear sunglasses. </p>
          </div>

          <div className="box-1">
            <img src={shadow} alt="Invalid dark and blurry photo" height={80} width={120} />
            <p className="error"> Don’t click a dark and blurry photo.</p>
          </div>
        </div>
      </div>
    );
  };
  return (
    <BottomPanel
      customComponent={getMobileUIPopup}
      setShowSection={props?.setShowPopup}
    />
  );
};
export default ViewPhotoSampleMobileViewProps;
